<template>
  <section>
    <div class="row">
      <div class="col">
        <h5>Shop Location Search</h5>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-4">
        <div class="row mt-3">
          <div class="col">
            <p>To search for Shop Locations, enter a postal code and radius (in miles), click 'Search'.</p>
          </div>
        </div>
        <div class="row custom-postal-code-wrapper">
          <div class="col">
            <div class="input-group">
              <span class="input-group-text">Postal Code:</span>
              <input type="text" v-model="postalCode" class="form-control custom-postal" placeholder="postal code" @keyup.enter="addPostalCode" />
              <!-- <button class="btn btn-success custom-focus" type="button" title="add postal code" tabindex="-1" @click="addPostalCode">
                <FontAwesomeIcon icon="fas fa-plus" />
              </button> -->
              <button
                class="btn btn-secondary custom-focus"
                type="button"
                title="show postal codes"
                tabindex="-1"
                :disabled="!anyPostalCodes"
                @click="showPostalCodes"
              >
                <span class="custom-num-postal-codes">{{ numPostalCodes }}</span>
                <FontAwesomeIcon v-if="!isShowPostalCodes" icon="fas fa-chevron-up" />
                <FontAwesomeIcon v-else icon="fas fa-chevron-down" />
              </button>
              <span class="input-group-text">Radius:</span>
              <input type="number" v-model="radius" class="form-control custom-radius" placeholder="radius" max="50" @input="handleRadiusInput" />
              <button class="btn btn-warning custom-focus" type="button" title="clear" tabindex="-1" @click="clearSearch">
                <FontAwesomeIcon icon="fas fa-times" />
              </button>
              <button class="btn btn-primary" tabindex="-1" :disabled="!gotPostalCode" @click="searchForShops">
                <FontAwesomeIcon icon="fas fa-search" />
              </button>
            </div>
          </div>
          <div v-if="isShowPostalCodes" class="custom-postal-codes">
            <ul>
              <li v-for="(code, idx) of postalcodes" :key="idx">
                <span>{{ code }}</span>
                <button class="btn btn-link custom-trash" @click="removePostalCode(idx)">
                  <FontAwesomeIcon icon="fas fa-trash-can" />
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col">
            <ul class="custom-list-header">
              <li>
                <div class="row">
                  <div class="col">
                    <span class="custom-header">Location Name</span>
                  </div>
                  <div class="col">
                    <span class="custom-header">Postal Code</span>
                  </div>
                </div>
              </li>
            </ul>
            <ul class="custom-list">
              <li v-for="(shop, idx) of shops" :key="idx">
                <div class="row">
                  <div class="col">
                    <span>{{ shop.firmName }}</span>
                  </div>
                  <div class="col">
                    <span>{{ shop.postalCode }}</span>
                  </div>
                </div>
              </li>
            </ul>
            <!-- <button v-if="gotPostalCode" class="btn btn-primary btn-sm" :disabled="isLoading" @click="downloadShops">Download</button> -->
          </div>
        </div>
      </div>
      <div class="col">
        <span>Current Locations being Served:</span>
        <LocationServing :isConfig="false" ref="servingLocations" :firm="provider" :isSearch="true" />
      </div>
    </div>
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { locationStore } from '@/stores/location'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Parser } from '@json2csv/plainjs'
import moment from 'moment'
import LocationServing from '@/components/locations/forms/LocationServing.vue'
export default {
  name: 'SearchShops',
  components: {
    FontAwesomeIcon,
    LocationServing
  },
  data() {
    return {
      isLoading: false,
      postalCode: null,
      radius: 5,
      provider: {
        firmClass: 'Service Provider',
        type: null
      },
      isShowPostalCodes: false,
      postalcodes: []
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(locationStore, ['loading', 'foundShops']),
    isFound() {
      return this.foundShops !== null
    },
    isLoading() {
      return this.loading.searchShops
    },
    shops() {
      return this.foundShops
    },
    firm() {
      let _firm = null
      if (this.profile) {
        _firm = this.profile.firm
      }
      return _firm
    },
    numPostalCodes() {
      return this.postalcodes.length
    },
    gotPostalCode() {
      return this.postalCode || this.postalcodes.length > 0
    },
    anyPostalCodes() {
      return this.postalcodes.length > 0
    }
  },
  methods: {
    ...mapActions(locationStore, ['searchShops', 'resetSearch', 'resetLocation', 'setLocation']),
    init() {
      this.isShowPostalCodes = false
      if (this.profile) {
        this.postalCode = this.profile.postalCode
      }
      setTimeout(() => {
        this.resetLocation()
        this.setLocation({
          name: 'firm',
          value: this.firm
        })
        this.$refs.servingLocations.search()
      }, 400)
    },
    addPostalCode() {
      if (this.postalCode) {
        this.postalcodes.push(this.postalCode)
        this.postalCode = null
      }
      console.log('Postal Codes: ', this.postalcodes)
    },
    removePostalCode(idx) {
      this.postalcodes.splice(idx, 1)
    },
    showPostalCodes() {
      this.isShowPostalCodes = !this.isShowPostalCodes
    },
    clearSearch() {
      this.resetSearch()
      this.postalCode = null
      this.postalcodes = []
      this.radius = 5
    },
    async searchForShops() {
      if (this.postalCode || this.postalcodes.length > 0) {
        let codes = this.postalCode
        if (this.postalcodes.length > 0) {
          codes = this.postalcodes.join(',')
        }
        this.isLoading = true
        let query = {
          search: '-',
          type: 6,
          firm: 1,
          firmType: 7,
          postalCode: codes,
          radius: Math.min(this.radius, 50)
        }
        await this.searchShops(query)
        console.log('Found Shops: ', this.foundShops)
        this.isLoading = false
      }
    },
    handleRadiusInput(e) {
      if (e.target.value > 50) {
        this.radius = 50;
      } else if (e.target.value < 0) {
        this.radius = 0;
      } else {
        this.radius = Number(e.target.value);
      }
    },
    downloadShops() {
      var now = moment().format('MMDDYY')
      var fields = null
      if (this.foundShops) {
        if (this.foundShops.length > 0) {
          const json2csvParser = new Parser({ fields })
          const csv = json2csvParser.parse(this.foundShops)
          // download the file as CSV
          var downloadLink = document.createElement('a')
          var blob = new Blob(['\ufeff', csv])
          var url = URL.createObjectURL(blob)
          downloadLink.href = url
          downloadLink.download = `Found Shops ${now}.csv`
          document.body.appendChild(downloadLink)
          downloadLink.click()
          document.body.removeChild(downloadLink)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-postal {
  width: 160px !important;
  max-width: 160px !important;
}
.custom-radius {
  max-width: 80px !important;
  text-align: right;
}
.custom-list-header {
  list-style-type: none;
  padding: 0;
  li {
    border-bottom: 1px solid #ccc;
  }
}
.custom-header {
  font-weight: 500;
}
.custom-list {
  list-style-type: none;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 500px;
  li {
    padding: 5px;
    border-bottom: 1px solid #ccc;
    &:first-child {
      padding-top: 0;
    }
    &:hover {
      background-color: #f9f9f9;
    }
  }
}
.custom-postal-code-wrapper {
  position: relative;
}
.custom-num-postal-codes {
  position: absolute;
  font-size: 0.8rem;
  font-weight: 500;
  top: -3px;
  right: 8px;
}
.custom-postal-codes {
  position: absolute;
  background-color: #f9f9f9;
  z-index: 999999;
  top: 38px;
  left: 110px;
  width: 42%;
  border: 1px solid #ccc;
  box-shadow: 4px 4px 7px -4px rgba(0, 0, 0, 0.76);
  -webkit-box-shadow: 4px 4px 7px -4px rgba(0, 0, 0, 0.76);
  -moz-box-shadow: 4px 4px 7px -4px rgba(0, 0, 0, 0.76);
  ul {
    list-style-type: none;
    padding: 5px;
    li {
      padding: 5px;
      border-bottom: 1px solid #ccc;
      &:first-child {
        padding-top: 0;
      }
      &:hover {
        background-color: #f9f9f9;
      }
    }
  }
}
.custom-trash {
  position: relative;
  color: red;
  font-size: 0.8rem;
  padding: 0;
  margin: 0;
  float: right;
}
</style>
